import React from "react";
import { Form, Input, Row, Col, Table, Button, Select, Tag, Space } from "antd";
import { setSelectedFinishGoods } from "../store/stateSlice";
import { useDispatch, useSelector } from "react-redux";
const { Option } = Select;
const FinishGoods = (props) => {
  const { values, handleBlur, handleChange, finishGoods, resetForm } = props;
  const dispatch = useDispatch();

  const data = useSelector((state) => state.bom_form.state.selectedFinishGoods);
  console.log(data);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Part Number",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Material Grade",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Drawing Number",
      key: "tags",
      dataIndex: "tags",
      render: (_, { tags }) => (
        <>
          {tags?.map((tag) => {
            let color = tag.length > 5 ? "geekblue" : "green";
            if (tag === "loser") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a>Invite {record.name}</a>
          <a>Delete</a>
        </Space>
      ),
    },
  ];

  const handleSelectChange = (product_id) => {
    const selectedProduct = finishGoods.find(
      (type) => type.Product?.product_id === product_id
    );

    handleChange({
      target: {
        name: "Finish_Good",
        value: {
          product_id: selectedProduct?.Product?.product_id,
          part_name: selectedProduct?.Product?.part_name,
          drawing_number: selectedProduct?.Product?.drawing_number,
          material_grade_id: selectedProduct?.Product?.MaterialGrade?.number,
        },
      },
    });
  };

  const filterOption = (input, option) => {
    const product = finishGoods.find(
      (type) => type.Product?.product_id === option.value
    );
    if (product) {
      const { part_name, part_number, MaterialGrade } = product.Product;
      return (
        part_name.toLowerCase().includes(input.toLowerCase()) ||
        part_number.toLowerCase().includes(input.toLowerCase()) ||
        MaterialGrade?.number.toLowerCase().includes(input.toLowerCase())
      );
    }
    return false;
  };

  const onFinishGood = () => {
    dispatch(
      setSelectedFinishGoods({
        Finish_Good: values.Finish_Good,
        quantity: values.quantity,
      })
    );
    resetForm({
      Finish_Good: "",
      quantity: "",
    });
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item className="flex flex-col">
            <span className="text-sm">Finish Goods</span>
            <Select
              showSearch
              placeholder="Select Finish Goods"
              onChange={handleSelectChange}
              // value={values.REPORTING_HEAD_ID}
              filterOption={filterOption}
              className="h-[40px] rounded"
            >
              {finishGoods?.map((type, index) => (
                <Option
                  key={index}
                  value={type.Product?.product_id}
                  className="text-gray-400"
                >
                  {`${type.Product?.part_name}, ${type.Product?.part_number}, ${type.Product?.Material_grade?.number}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item className="flex flex-col">
            <span className="text-sm">Quantity</span>
            <Input
              name="quantity"
              placeholder="Quantity"
              value={values.quantity}
              onChange={handleChange}
              onBlur={handleBlur}
              className="!rounded"
              style={{ padding: "8px" }}
              size="large"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item className="flex items-center">
            <Button
              onClick={onFinishGood}
              type="primary"
              style={{ marginTop: "28px" }}
            >
              Add
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <div className="mt-4">
        <Table columns={columns} dataSource={data} />
      </div>
    </>
  );
};

export default FinishGoods;
